/**
 * Google OAuth client config. The client_id is a public string — it identifies our
 * OAuth client to Google but isn't a secret on its own. Hardcoded here rather than
 * injected at build time, same way the Auth0 config used to be.
 *
 * Update this string after creating a new "Web application" OAuth 2.0 Client ID in the
 * Google Cloud Console. The same value lives in SSM `/access-ops/google-client-id`
 * which the Lambda reads at boot to validate `aud` on incoming id_tokens.
 */
export const googleClientId = '118466778235-fuomver9i7p3mc1vq66ukou5jeojokfh.apps.googleusercontent.com';
